import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  taxGroup: {},
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
